import React, { useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { DocumentScanner } from "@mui/icons-material";
import { useRef } from "react";
import { formatSignatureDate } from "../../../utils/formatSignatureDate";
import { connect } from "react-redux";
import moment from "moment";
import { imageToBase64 } from "../../../utils/imageToBase64";
import { uploadCRMDocumentAndGetUrl } from "../../../utils/uploadDocument";
import { post } from "../../../api";

export const generatePDF = async (data, user, sasToken, isSendToTalentTrail = false, token, candidateId) => {
  const doc = new jsPDF();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Health questionnaire", 105, 30, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Personal Information", 105, 40, { align: "center" });

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Health questionnaire to assess if you are fit to work nights", 10, 50);

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.text(`The purpose of this questionnaire is to make sure that you are suited to working at night. All the information you provide will be kept
confidential.`, 10, 60);
  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Title", 10, 80);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.title}`, 10, 85);

   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("First Name", 10, 95);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.firstName}`, 10, 100);

   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("Surname", 10, 110);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.surName}`, 10, 115);

   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("Home Address", 10, 125);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.homeAddress}`, 10, 130);


   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("Postcode", 10, 140);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.postCode}`, 10, 145);

   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("Mobile Number", 10, 155);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.mobile}`, 10, 160);

   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("Landline Number", 10, 170);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.landlineNumber ? data?.landlineNumber : ''}`, 10, 175);

   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("Email Address", 10, 185);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.email}`, 10, 190);

   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("DOB", 10, 200);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.dateOfBirth}`, 10, 205);

   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("Job Title", 10, 215);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.jobTitle}`, 10, 220);
   //
   doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("National Insurance Number", 10, 230);
   doc.setFont("helvetica", "normal");
   doc.setFontSize(10);
   doc.text(`${data?.nationalInsuranceNumber}`, 10, 235);

  // Table Data
  doc.addPage();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Health conditions", 105, 30, { align: "center" });

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Do you suffer from any of the following health conditions?", 10, 50);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Diabetes", 10, 60);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.healthConditions?.includes("Diabetes") ? "Yes" : "Not answered"}`, 10, 65);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Heart or circulatory disorders", 10, 75);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.healthConditions?.includes("Heart or circulatory disorders") ? "Yes" : "Not answered"}`, 10, 80);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Stomach or intestinal disorders", 10, 90);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.healthConditions?.includes("Stomach or intestinal disorders") ? "Yes" : "Not answered"}`, 10, 95);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Any condition which causes difficulties sleeping", 10, 105);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.healthConditions?.includes("Any condition which causes difficulties sleeping") ? "Yes" : "Not answered"}`, 10, 110);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Chronic chest disorders (especially if night-time symptoms are troublesome)", 10, 120);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.healthConditions?.includes("Chronic chest disorders (especially if night-time symptoms are troublesome") ? "Yes" : "Not answered"}`, 10, 125);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Any medical condition requiring medication to a strict timetable", 10, 130);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.healthConditions?.includes("Any medical condition requiring medication to a strict timetable") ? "Yes" : "Not answered"}`, 10, 140);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Any other health factors that might affect fitness at work", 10, 150);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.healthConditions?.includes("Any other health factors that might affect fitness at work") ? "Yes" : "Not answered"}`, 10, 155);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Other Factor?", 10, 165);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.otherOtherCondition ? data?.otherOtherCondition : 'No'}`, 10, 170);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("If you have answered 'yes' to any of the above questions, you may be asked to see a doctor or nurse", 10, 180);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.healthConditionConsentAgree ? data?.healthConditionConsentAgree : 'Disagree'}`, 10, 185);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("I, the undersigned, confirm that the above is correct to the best of knowledge", 10, 195);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.healthConditionConsent ? data?.healthConditionConsent : 'No'}`, 10, 200);

  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const margin = 10;

  doc.setFontSize(10);
  let currentHeight = margin;
  doc.addPage();
  currentHeight = 20;

  // Set bold text on the left
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Title", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text("Health questionnaire", pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left

  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Provided by", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text("Rapid Resourcing", pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  doc.line(margin, currentHeight, pageWidth - margin, currentHeight); // Draw a horizontal line across the page
  currentHeight += 10; // Move down a little to make space for the paragraph
  // Add paragraph text after the line
  const paragraphText = `By signing this page, I confirm that I fully understand the content and agree to adhere to it at all times. I also agree that all the details provided in this document are accurate and complete to the best of my knowledge.`;

  // Use splitTextToSize to fit the paragraph within the page width
  const paragraphLines = doc.splitTextToSize(
    paragraphText,
    pageWidth - 2 * margin
  );

  // Add the paragraph to the document
  doc.setFontSize(10);
  doc.text(paragraphLines, margin, currentHeight); // Render paragraph
  currentHeight += 20;

  // Add paragraph text after the line
  const paragraphText2 = `By ticking this box I consent to the company processing my data and the evidence of this document being stored within their system for the purpose of work finding services.`;

  // Use splitTextToSize to fit the paragraph within the page width
  const paragraphLines2 = doc.splitTextToSize(
    paragraphText2,
    pageWidth - 2 * margin
  );

  // Add the paragraph to the document
  doc.text(paragraphLines2, margin, currentHeight); // Render paragraph
  currentHeight += 40;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Date Signed", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.signDate ? moment(data?.signDate).format("DD-MM-YYYY") : '--'}`, pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  // Add signature image from URL
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signature", margin, currentHeight);

  // Add the signature image if the URL exists
  if (data?.signature) {
    try {
      const imgData = await imageToBase64(`${data.signature}?${sasToken}`);
      doc.addImage(imgData, "JPEG", pageWidth * 0.4, currentHeight, 30, 15);
    } catch (e) {
      console.error("Error loading signature image:", e);
    }
  }
  currentHeight += 20;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Name", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(
    `${user?.firstName} ${user?.lastName}`,
    pageWidth * 0.4,
    currentHeight
  ); // Add the normal text 30% from the left
  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("IP Address", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.ipAddress}`, pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  // Save the PDF
  if (isSendToTalentTrail) {
    const pdfBlob = doc.output("blob");
    const formData = new FormData();
    formData.append(
      "file",
      pdfBlob,
      `health-questionnaire-${user?.firstName}-${user?.lastName}.pdf`
    );
    formData.append("candidateId", candidateId);
    const documentUrl =
      (await uploadCRMDocumentAndGetUrl(formData, token)) || "";
    console.log("documentUrl", documentUrl);
    if (documentUrl) {
      const payload = {
        candidateId,
        fileName: `health-questionnaire-${user?.firstName}-${user?.lastName}.pdf`,
        fileExtention: ".pdf",
        fileType: "workExperience",
        fileLink: documentUrl,
        licenseNo: "rapidresourcing",
      };

      const url = "/api/candidate/save-document";
      try {
        const res2 = await post(url, payload);
        console.log("Document saved successfully:", res2.data);
      } catch (error) {
        console.error("Error saving document:", error);
      }
    } else {
      console.error("Failed to upload document, skipping save.");
    }
  } else {
    doc.save(`health-questionnaire-${user?.firstName}-${user?.lastName}.pdf`);
  }
};

const HealthQuestionnaireDownload = ({ user, data, sasToken }) => {
  const signatureRef = useRef(null); // Create a reference to the image element
  useEffect(() => {
    if (signatureRef.current) {
      // Set the crossOrigin attribute to allow cross-origin image loading
      signatureRef.current.crossOrigin = 'anonymous';
    }
  }, []);
  
  return (
    <>
      <div className="text-center p-4 document-sign">
        <p>{formatSignatureDate(data?.signDate, user)}</p>
        <div>
          {data?.signature && <img
            ref={signatureRef}
            src={`${data?.signature}?${sasToken}`}
          />}
          
        </div>
      </div>
      <div className="text-center w-100 mt-4">
        <button className="btn btn-success btn-lg" onClick={() => generatePDF(data, user, sasToken)}>
          <DocumentScanner /> Download your receipt
        </button>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(HealthQuestionnaireDownload);
